/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Otherdepartmentfurtherinformation3Inputs */

const en__field_otherdepartmentfurtherinformation3 = /** @type {(inputs: _Field_Otherdepartmentfurtherinformation3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Others: Further information`)
};

const de__field_otherdepartmentfurtherinformation3 = /** @type {(inputs: _Field_Otherdepartmentfurtherinformation3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstige: Weitere Informationen`)
};

/**
* | output |
* | --- |
* | "Others: Further information" |
*
* @param {_Field_Otherdepartmentfurtherinformation3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_otherdepartmentfurtherinformation3 = /** @type {((inputs?: _Field_Otherdepartmentfurtherinformation3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Otherdepartmentfurtherinformation3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_otherdepartmentfurtherinformation3(inputs)
	return de__field_otherdepartmentfurtherinformation3(inputs)
});
export { _field_otherdepartmentfurtherinformation3 as "_field_otherDepartmentFurtherInformation" }